import { ALL_TAB_EXPANDED_MAX_ITEM_COUNT, ALL_TAB_PREVIEW_ITEM_COUNT } from "app/components/React/QuickSearch/config";

export function sliceQuickSearchExpandableList<T>(items: T[], isExpanded: boolean): T[] {
    if (items.length <= ALL_TAB_PREVIEW_ITEM_COUNT) {
        return items;
    }
    const limit = isExpanded ? ALL_TAB_EXPANDED_MAX_ITEM_COUNT : ALL_TAB_PREVIEW_ITEM_COUNT;
    return items.slice(0, limit);
}
